import React from 'react'
import _ from 'lodash'


export class QuickCollabs extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        let style = {
            left: this.props.x,
            top: this.props.y,
        }

        let users

        if (this.props.users.length === 1) {
            users = (
                <div key={i} className="collab-item">{_.first(this.props.users)}</div>
            )
        } else {
            users = _.map(this.props.users, (user, i) => {
                let nameParts = user.split(' ').slice(0, 2)
                let initials = _.map(nameParts, (namePart) => namePart[0].toUpperCase()).join('')

                return (
                    <div key={i} className="collab-item"><div className="user-icon white">{ initials }</div> { user }</div>
                )
            })
        }

        return (
            <div className="leg-collabs-popout" style={style}>
                <div className="collab-group">
                    { users }
                </div>
            </div>

        )
    }
}
